<template>
  <view class="tip-card">
    <view class="tips-item" wx:for="{{changeTicketTip}}" bindtap="toPurchaseNotice(index)">
      <view class="tips-icon"></view>
      <hl-text text="{{item}}" hlStyle="{{index ? detailStyle : hlStyle}}" class="tips-text" />
      <!-- <text wx:if="{{index == 1}}" bindtap="toPurchaseNotice" class="detail" wx:style="{{hlStyle}}">查看详情</text> -->
    </view>
    <!-- <text bindtap="toPurchaseNotice" class="detail" wx:style="{{hlStyle}}">查看详情</text> -->
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { filterHighlightText } from '@/common/public'
  import { innerRouter, pagePath } from '@/common/jump'

  createComponent({
    data() {
      return {
        changeTicketTip: [
          '已取票、已退票或已改签的车票无法改签。{{每张车票只能改签一次，改签成功后的车票不能再次改签！}}',
          '开车前不足48小时至发车后当日24时前改签发车当日后车次，铁路局会收取一定比例的改签费。{{查看详情>}}'
        ],
        hlStyle: {
          color: '#FF6400',
          fontWeight: 600
        },
        detailStyle: {
          color: '#FF6400',
          fontWeight: 500
        }
      }
    },
    methods: {
      toPurchaseNotice(index) {
        index && innerRouter.push(pagePath().ICKETPURCHASENOTICE, {
          checkTabIndex: 'change'
        })
      }
    }
  })
</script>

<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .tip-card
    margin-bottom 10px
    background #FFF4EE
    padding 10px
    box-sizing border-box
    border-radius 8px
    font-family PingFangSC-Regular
    font-size 12px
    font-weight normal
    line-height 18px
    letter-spacing 0px
    color #333333
    position relative
  .tips-item
    position relative
  .tips-icon
    position absolute
    width 2px
    height 2px
    background #222222
    border-radius 50%
    top 9px
    left 0
  .tips-text
    margin-left 4px
  // .detail
  //   color #FF6400
  //   position relative
  //   margin-top 2px
  //   line-height 18px
  //   &::after
  //     content ''
  //     top 6px
  //     right -8px
  //     position absolute
  //     width 4px
  //     height 4px
  //     border-top 1.5px solid
  //     border-right 1.5px solid
  //     transform rotate(45deg)
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'hl-text': '@/components/hl-text'
    }
  }
</script>